import dashboard from './menu/dashboard'
import administrator from './menu/administrator'
import rolePermission from './menu/rolePermission'
import store from './menu/store'

export default [...dashboard, ...administrator, ...rolePermission, ...store]
